import useSWR from "swr";
import { getStoryBySlug, useStoryblokState } from "@cinch-nx/data-storyblok";
import { getStoryblokSlugFromUrl } from "../../utils";
import { useSearchStore } from "..";
import { useRouter } from "next/router";
const fetcher = async ({ slug , isInsideStoryblok  })=>{
    const args = {
        version: isInsideStoryblok ? "draft" : "published",
        ...isInsideStoryblok && {
            cv: Date.now()
        }
    };
    return await getStoryBySlug(slug, args, {
        strict: false
    });
};
export function useStoryblokData() {
    var ref, ref1, ref2;
    const isInsideStoryblok = useSearchStore((s)=>s.isInsideStoryblok);
    const { asPath  } = useRouter();
    const slug = getStoryblokSlugFromUrl(asPath);
    const shouldFetch = slug !== "search/" && slug !== null;
    // See: https://swr.vercel.app/docs/conditional-fetching#conditional
    // and: https://swr.vercel.app/docs/arguments#multiple-arguments
    // For information on the advanced usage used here
    const { data , error , isLoading , isValidating  } = useSWR(shouldFetch ? [
        slug,
        isInsideStoryblok
    ] : null, ([slug, isInsideStoryblok])=>fetcher({
            slug,
            isInsideStoryblok
        }));
    const story = useStoryblokState({
        story: data || undefined,
        enableBridge: isInsideStoryblok
    });
    const content = story === null || story === void 0 ? void 0 : story.content;
    return {
        headingOverride: content === null || content === void 0 ? void 0 : content.HeadingOverride,
        intro: content === null || content === void 0 ? void 0 : (ref = content.Intro) === null || ref === void 0 ? void 0 : ref[0],
        faqs: content === null || content === void 0 ? void 0 : (ref1 = content.FAQ) === null || ref1 === void 0 ? void 0 : ref1[0],
        outro: content === null || content === void 0 ? void 0 : content.Outro,
        seo: content === null || content === void 0 ? void 0 : (ref2 = content.SEO) === null || ref2 === void 0 ? void 0 : ref2[0],
        isLoading,
        isValidating,
        error
    };
}
